import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import {
  GridToolbarContainer,
  QuickFilter,
  QuickFilterClear,
  QuickFilterControl,
  useGridApiContext,
  useGridRootProps
} from "@mui/x-data-grid";

export function ListGridToolbar(props) {
  const { quickFilterProps } = props;
  const anchorRef = useRef(null);
  const [host, setHost] = useState(null);
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();

  useEffect(() => {
    const anchor = anchorRef.current;
    const card = anchor?.closest(".card");
    const headerRow = card?.querySelector(".card-header--row");

    if (!headerRow) return undefined;

    let actions = headerRow.querySelector(".card-header-actions");
    let createdActions = false;

    if (!actions) {
      actions = document.createElement("div");
      actions.className = "card-header-actions card-header-actions--search-only";
      headerRow.appendChild(actions);
      createdActions = true;
    }

    const searchHost = document.createElement("div");
    searchHost.className = "data-grid-search-host";
    actions.insertBefore(searchHost, actions.firstChild);
    setHost(searchHost);

    return () => {
      setHost(null);

      if (searchHost.parentNode === actions) {
        actions.removeChild(searchHost);
      }

      if (createdActions && actions.childElementCount === 0 && actions.parentNode === headerRow) {
        headerRow.removeChild(actions);
      }
    };
  }, []);

  const quickFilterParser = quickFilterProps?.quickFilterParser;
  const quickFilterFormatter = quickFilterProps?.quickFilterFormatter;
  const debounceMs = quickFilterProps?.debounceMs;
  const rootTextFieldProps = quickFilterProps?.slotProps?.root ?? {};
  const rootTextFieldSlotProps = rootTextFieldProps.slotProps ?? {};
  const ToolbarIconButton = rootProps.slots.baseIconButton;
  const SearchIcon = rootProps.slots.quickFilterIcon;
  const ClearIcon = rootProps.slots.quickFilterClearIcon;
  const quickFilterClassName = ["data-grid-search-toolbar", quickFilterProps?.className].filter(Boolean).join(" ");

  return (
    <>
      <span ref={anchorRef} className="data-grid-toolbar-anchor" aria-hidden />
      {host
        ? createPortal(
            <QuickFilter
              expanded
              parser={quickFilterParser}
              formatter={quickFilterFormatter}
              debounceMs={debounceMs}
              render={(containerProps, state) => (
                <GridToolbarContainer {...containerProps} className={quickFilterClassName}>
                  <QuickFilterControl
                    {...rootTextFieldProps}
                    size={rootTextFieldProps.size ?? "small"}
                    placeholder={rootTextFieldProps.placeholder ?? apiRef.current.getLocaleText("toolbarQuickFilterPlaceholder")}
                    slotProps={{
                      ...rootTextFieldSlotProps,
                      input: {
                        ...rootTextFieldSlotProps.input,
                        startAdornment: <SearchIcon fontSize="small" />,
                        endAdornment: state.value ? (
                          <QuickFilterClear
                            render={
                              <ToolbarIconButton
                                size="small"
                                edge="end"
                                aria-label={apiRef.current.getLocaleText("toolbarQuickFilterDeleteIconLabel")}
                              >
                                <ClearIcon fontSize="small" />
                              </ToolbarIconButton>
                            }
                          />
                        ) : null
                      }
                    }}
                  />
                </GridToolbarContainer>
              )}
            />,
            host
          )
        : null}
    </>
  );
}
